const authentication = require('../../../react-azure-adb2c2').default;


export const calendar_list = (values: any) => {

    // let url = `http://localhost:5000/v1/m/calendar/group/members/calendarlist`;
    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/m/calendar/group/members/calendarlist`;

    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};

export const list = (value: any) => {

    // let url = `http://localhost:5000/v1/m/calendar/group/members/list/` + value;
    const url = process.env.REACT_APP_API_CRM_CONTACS_URL + `/v1/m/calendar/group/members/list/` + value;

    const token = authentication.getAccessToken();
    // alert(url)
    return fetch(url, {
        method: 'get',
        // body: JSON.stringify(values),

        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' },

    }).then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

};
